import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/app/web/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/app/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Drawer, Form, Input, message, Popconfirm, Switch } from 'antd';
import { TaskIncidenceState } from 'core/client';
import { getAuthStore } from 'core/modules/auth/auth.store';
import { getTaskStore } from 'core/modules/tasks/task.store';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TaskFormDeadline } from 'src/components/Tasks/Form/Deadline';
import { formHasErrors, formIsTouched } from 'src/utils/form';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TaskIncidenceDrawer = function TaskIncidenceDrawer(props) {
  var _props$incidence, _props$incidence2;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getTaskStore = getTaskStore(),
      isLoading = _getTaskStore.isLoading,
      addTaskIncidence = _getTaskStore.addTaskIncidence,
      updateTaskIncidence = _getTaskStore.updateTaskIncidence,
      deleteTaskIncidence = _getTaskStore.deleteTaskIncidence;

  var _getAuthStore = getAuthStore(),
      user = _getAuthStore.user,
      canManageTasks = _getAuthStore.canManageTasks;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var isCreating = props.isVisible && !props.incidence;

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
      var _props$task;

      var _props$incidence3;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if ((_props$task = props.task) !== null && _props$task !== void 0 && _props$task.id) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.prev = 2;

              if (!isCreating) {
                _context.next = 10;
                break;
              }

              _context.next = 6;
              return addTaskIncidence(props.task.id, data);

            case 6:
              message.success(t('tasks.newIncidence'));
              form.resetFields();
              _context.next = 13;
              break;

            case 10:
              _context.next = 12;
              return updateTaskIncidence(props.task.id, (_props$incidence3 = props.incidence) === null || _props$incidence3 === void 0 ? void 0 : _props$incidence3.id, data, data.completed ? TaskIncidenceState.Done : TaskIncidenceState.Pending);

            case 12:
              message.success(t('tasks.incidenceUpdated'));

            case 13:
              _context.next = 18;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](2);
              message.error(t('unknownError'));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 15]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  function onDeletionConfirmed() {
    return _onDeletionConfirmed.apply(this, arguments);
  }

  function _onDeletionConfirmed() {
    _onDeletionConfirmed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _props$task2, _props$incidence4;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!((_props$task2 = props.task) !== null && _props$task2 !== void 0 && _props$task2.id) || !((_props$incidence4 = props.incidence) !== null && _props$incidence4 !== void 0 && _props$incidence4.id))) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return deleteTaskIncidence(props.task.id, props.incidence.id);

            case 5:
              message.success(t('tasks.incidenceDeleted'));
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](2);
              message.error(t('unknownError'));

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 8]]);
    }));
    return _onDeletionConfirmed.apply(this, arguments);
  }

  useEffect(function () {
    form.resetFields();

    if (props.incidence) {
      form.setFieldsValue(_objectSpread(_objectSpread({}, props.incidence), {}, {
        completed: props.incidence.state === 'done'
      }));
    }
  }, [props.incidence]);
  return /*#__PURE__*/_jsx(Container, {
    width: 400,
    open: props.isVisible,
    onClose: props.onClose,
    title: isCreating ? t('tasks.new') : (_props$incidence = props.incidence) === null || _props$incidence === void 0 ? void 0 : _props$incidence.title,
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      colon: false,
      form: form,
      onFinish: onSubmit,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "title",
        label: t('form.incidence.title.label'),
        rules: [{
          required: true,
          message: t('form.incidence.title.error.required')
        }],
        children: /*#__PURE__*/_jsx(Input, {
          bordered: !props.isReadonly,
          readOnly: props.isReadonly,
          placeholder: props.isReadonly ? t('form.incidence.title.empty') : t('form.incidence.title.placeholder')
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "description",
        label: t('form.incidence.description.label'),
        children: /*#__PURE__*/_jsx(Input.TextArea, {
          autoSize: {
            minRows: props.isReadonly ? undefined : 2
          },
          bordered: !props.isReadonly,
          readOnly: props.isReadonly,
          placeholder: props.isReadonly ? t('form.incidence.description.empty') : t('form.incidence.description.placeholder')
        })
      }), /*#__PURE__*/_jsx(TaskFormDeadline, {
        isReadonly: props.isReadonly
      }), !isCreating && /*#__PURE__*/_jsx(Form.Item, {
        name: "completed",
        label: t('form.incidence.solved.label'),
        valuePropName: "checked",
        children: /*#__PURE__*/_jsx(Switch, {})
      }), /*#__PURE__*/_jsxs("div", {
        className: "ant-drawer-footer",
        children: [/*#__PURE__*/_jsx("div", {
          className: "actions-left",
          children: !isCreating && (canManageTasks || ((_props$incidence2 = props.incidence) === null || _props$incidence2 === void 0 ? void 0 : _props$incidence2.authorId) === user.id) && /*#__PURE__*/_jsx(Popconfirm, {
            getPopupContainer: function getPopupContainer(trigger) {
              return trigger.parentElement;
            },
            title: t('areYouSure'),
            icon: /*#__PURE__*/_jsx(QuestionCircleOutlined, {
              style: {
                color: 'red'
              }
            }),
            okText: t('yes'),
            cancelText: t('cancel'),
            onConfirm: onDeletionConfirmed,
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              danger: true,
              disabled: isLoading,
              children: t('delete')
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "actions-right",
          children: /*#__PURE__*/_jsx(Form.Item, {
            shouldUpdate: true,
            validateFirst: true,
            children: function children(form) {
              return /*#__PURE__*/_jsx(Button, {
                type: "primary",
                disabled: isLoading || !formIsTouched(form) || formHasErrors(form),
                loading: isLoading,
                htmlType: "submit",
                onClick: form.submit,
                children: t('save')
              });
            }
          })
        })]
      })]
    })
  });
}; // Styles

var Container = styled(Drawer).withConfig({
  displayName: "IncidencesDrawer__Container",
  componentId: "sc-91g1yp-0"
})([".ant-drawer-footer{position:absolute;right:0;bottom:0;left:0;background:white;z-index:1000;.actions-left{float:left;}.actions-right{float:right;}.create-another{padding:5px;.create-another-label{margin-right:3px;margin-left:6px;}}.ant-form-item{margin-bottom:0 !important;}}"]);